<template>
  <section class="container mx-auto flex lg:flex-row flex-col items-center w-full py-12 px-10">
    <div class="h-72 w-72 mb-10 lg:mb-0" v-if="foto">
      <component :is="link ? 'a' : 'div'" :href="link || null" target="_blank" class="block h-full w-full">
        <img class="h-full w-full rounded-full" :src="foto" alt="speaker" />
      </component>
    </div>
    <div class="flex-1 items-center text-center lg:text-left">
      <div class=" md:px-9 lg:ml-9 border-b">
        <h5 class="tracking-normal text-theme-color">{{tipo}}</h5>
        <a v-if="link" :href="link" target="_blank">
          <h3 class="text-3xl font-medium mb-2">{{nombre}}</h3>
        </a>
        <h3 v-else class="text-3xl font-medium mb-2">{{nombre}}</h3>
        <div class="flex mb-4 lg:justify-start justify-center" v-if="universidad || ciudad">
          <span class="flex items-center" v-if="universidad">
            <span>{{universidad}}</span>
          </span>
          <span v-if="ciudad" :class="universidad ? 'ml-3 pl-3 border-l-2 border-gray-200' : null" class="flex py-2 space-x-2s">
            <span class="flex items-center gap-1">
              {{ciudad}}
              <img v-if="codigoPais" :src="`https://flagcdn.com/80x60/${codigoPais}.png`" width="20" height="15" :alt="ciudad" />
            </span>
          </span>
        </div>
        <p class="mb-8 leading-relaxed" v-if="tieneDescripcion">
          {{descripcion}}
        </p>
        <div class="mb-10 grid grid-cols-[auto_1fr] gap-x-3 gap-y-1 items-center" v-if="areat || tema || cupo">
          <template v-if="areat">
            <small class="text-gray-500"><b>Área Temática: </b></small>
            <span class="inline-block py-1 px-2 rounded bg-theme-color-light text-theme-color text-xs font-medium tracking-normal">{{areat}}</span>
          </template>
          <template v-if="tema">
            <small class="text-gray-500"><b>{{etiquetaTema}}: </b></small>
            <span class="inline-block py-1 px-2 rounded bg-theme-color-light text-theme-color text-xs font-medium tracking-normal" v-html="tema"></span>
          </template>
          <template v-if="cupo">
            <small class="text-gray-500">Cupos:</small>
            <span class="inline-block py-1 px-2 rounded bg-theme-color-light text-theme-color text-xs font-medium tracking-normal">{{cupo}}</span>
          </template>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import { codigoPais } from '@/utils/paises';

export default {
  props: ["nombre", "tipo", "descripcion", "foto", "universidad", "ciudad", "areat", "tema", "link", "cupo"],
  computed: {
    tieneDescripcion() {
      return !!this.descripcion && this.descripcion.trim() !== '' && this.descripcion.trim() !== '.';
    },
    etiquetaTema() {
      const etiquetas = { Tallerista: 'Taller', Panelista: 'Panel' };
      return etiquetas[this.tipo] || 'Conferencia';
    },
    codigoPais() {
      return codigoPais(this.ciudad);
    }
  }
};
</script>

<style scoped>
</style>
